/* eslint-disable react/require-default-props */
import React from 'react';
import styled from 'styled-components';
import LeftArrow from '~/components/shared/LeftArrow/LeftArrow';
import Logo from '~/components/shared/LogoOld/LogoOld';
import {
  FontWeights,
  Typography,
} from '~/components/shared/Typography/Typography';
import { ComponentSize } from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';

const PaymentMethodsHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: center;
  height: 5em;
  box-shadow: 0 0.25em 1.25em -0.25em #00000020;
  margin-bottom: 0.25em;
  background-color: white;
  @media (orientation: landscape) {
    margin-bottom: 1em;
  }
`;

const InvoiceHeaderChildrenContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-right: 2em;
  padding-left: 2em;
  @media (orientation: landscape) {
    max-width: 40em;
  }
`;

const InvoiceHeaderBackButtonHolder = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`;

const InvoiceHeaderLogoHolder = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  aligin-items: center;
`;

const InvoiceHeaderInvisibleHolder = styled.div`
  flex: 2;
`;

interface Props {
  onCancelButton?: () => void;
  hideCancelButton?: boolean;
  text?: string;
}

const PaymentMethodsHeader: React.FC<Props> = (props) => {
  const { onCancelButton, text, hideCancelButton } = props;

  return (
    <PaymentMethodsHeaderContainer>
      <InvoiceHeaderChildrenContainer>
        <InvoiceHeaderBackButtonHolder onClick={onCancelButton}>
          {!hideCancelButton && (
            <div>
              <LeftArrow color={theme.colors.accent} />
              <Typography
                style={{ marginBottom: '10px' }}
                fontSize={1}
                color={theme.colors.accent}
                fontWeight={FontWeights.Normal}
              >
                {text || 'Cancel'}
              </Typography>
            </div>
          )}
        </InvoiceHeaderBackButtonHolder>
        <InvoiceHeaderLogoHolder>
          <Logo mt={1} mb={1} size={ComponentSize.Small} />
        </InvoiceHeaderLogoHolder>
        <InvoiceHeaderInvisibleHolder />
      </InvoiceHeaderChildrenContainer>
    </PaymentMethodsHeaderContainer>
  );
};

export default PaymentMethodsHeader;
